import { client } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = ({ fspId, ...params }) =>
  client.executeRequest('GET', `fsps/${fspId}/mlinsights`, {
    queryParams: { ...params },
    returnModel: { name: 'mlinsights' },
  });
